export default "__VITE_ASSET__DbXIv2GO__"